import { render } from "./UserInfoPage.vue?vue&type=template&id=e73f7052&scoped=true"
import script from "./UserInfoPage.vue?vue&type=script&lang=js"
export * from "./UserInfoPage.vue?vue&type=script&lang=js"

import "./UserInfoPage.vue?vue&type=style&index=0&id=e73f7052&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e73f7052"]])

export default __exports__